<template>
  <!--    hero-area-start-->
  <div class="hero-area" style="background-image: url(assets/img/hero-img-dl.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="hero-containt position-relative black">
            <h3 class="black">Digital Leaders <br />in Higher Education</h3>
            <img :src="logo" alt="" width="350" />
            <p class="black bold">
              {{ intro }}
            </p>
            <div class="hero-btn" v-if="buttonText">
              <router-link :to="buttonLink" class="theme-btn">{{ buttonText }}</router-link>
            </div>

            <!-- <div class="hero-global">
              <img src="assets/img/g-whait.png" alt="" />
              <p>The Global Employability University Ranking & Survey</p>
              <router-link to="/geurs2020" class="theme-btn">Consult GEURS 2020</router-link>
              <img src="assets/img/glo-bot.png" alt="" class="glo-dot" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
import { getSingle } from '@/api/navItems';

export default {
  data() {
    return {
      textElements: {}
    };
  },
  props: {
    logo: {
      type: String,
      default: 'assets/img/logodl-2.png'
    },
    intro: {
      type: String,
      default: `Innovative set of rankings produced by Emerging, identify for the first time which
              Higher Education Institutions are global champions for digital education worldwide,
              and the best dynamic digital clusters for study and work.`
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: ''
    }
  },
  created() {
    getSingle('home-entreprises').then(res => {
      this.textElements = res.text_template;
    });
  }
};
</script>

<style lang="scss" scoped>
h3,
h4 {
  margin: 0px 0px 15px;
}

.black {
  color: black;
}

.bold {
  font-weight: bold;
}
</style>
